import { render, staticRenderFns } from "./feedBackReply.vue?vue&type=template&id=8a3045c2&"
import script from "./feedBackReply.vue?vue&type=script&lang=js&"
export * from "./feedBackReply.vue?vue&type=script&lang=js&"
import style0 from "./feedBackReply.vue?vue&type=style&index=0&id=8a3045c2&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xcll/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8a3045c2')) {
      api.createRecord('8a3045c2', component.options)
    } else {
      api.reload('8a3045c2', component.options)
    }
    module.hot.accept("./feedBackReply.vue?vue&type=template&id=8a3045c2&", function () {
      api.rerender('8a3045c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/xcpCustomerService/feedBackReply/feedBackReply.vue"
export default component.exports